import { useEffect } from 'react'

const GoogleTranslateScript = () => {
    const googleTranslateElementInit = () => {
        window['translateElement'] = new (window as any)['google'].translate.TranslateElement(
            {
                pageLanguage: 'en',
                includedLanguages: 'nl,fr,de,es,pt,it,ar,fi',
                layout: (window as any)['google'].translate.TranslateElement.InlineLayout.SIMPLE,
                autoDisplay: false,
            },
            'google_translate_element',
        )
    }

    useEffect(() => {
        if (!window['googleTranslateElementInit']) {
            window['googleTranslateElementInit'] = googleTranslateElementInit
            const script = document.createElement('script')
            script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
            script.async = true
            document.head!.appendChild(script)
        }
    })

    return null
}

export default GoogleTranslateScript
